import { render, staticRenderFns } from "./TreeTransfer.vue?vue&type=template&id=113e66d2&"
import script from "./TreeTransfer.vue?vue&type=script&lang=js&"
export * from "./TreeTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports